import React, {useRef, useState} from "react";
import PropTypes from "prop-types";
import Currency from "../../../../../components/Currency/Currency";
import {_t} from "../../../../../utils/I18nUtils";

export const ViewMode = {
    DEFAULT : 0,
    CUSTOM: 1,
    AS_BUTTON: 2,
};

const trKey = 'components.addFundsForm.productSelection.productItem';

const ProductItemMobile = ({product,
                               viewMode,
                               hasUsedPromo, isSelected, selected, onProductSelected }) => {

    const [customPrice, setCustomPrice] = useState(String(product.price));
    const [currentViewMode, setViewMode] = useState(viewMode);
    const shouldShowPromo = hasUsedPromo !== undefined && !hasUsedPromo;
    const [inputFocus, setInputFocus] = useState(false);
    const inputRef = useRef(null);

    const renderProduct = (p) => {
        return (
            <div className={"ProductItem " + (isSelected ? "selected" : "")}
                 key={p.productId}>
                <div className="detailsCol">
                    <h3>
                        <span className="addAmount">{_t(`${trKey}.${p.productId}`)}</span>
                        {shouldShowPromo && (
                            <span className="bonus">
                                + {_t(`${trKey}.weWillAdd`)} &nbsp;
                                <span className="freeBets">
                                    <Currency value={p.price || 0}
                                              removeDecimal
                                              currency={'TF'} />
                                    {_t(`${trKey}.freeBets`)}
                                </span>
                            </span>
                        )}
                    </h3>
                </div>
                <div className="priceCol">
                    <div className={"toggleSlide " + (isSelected ? "on" : "off")}
                         onClick={() => onProductSelected(p)}>
                        <span className="toggleBtn"></span>
                    </div>
                </div>
            </div>
        );
    };

    const renderProductAsButton = (p) => {
        return <button id={p.id}
                       className={"ProductItem asButton " + (isSelected ? "selected" : "")}
                       onClick={() => onProductSelected(p)}>
            <Currency value={p.price} currency={p.currency} removeDecimal={true} />
        </button>;
    }

    const renderCustomProduct = (p) => {
        const handleClick = () => {
            const price = parseFloat(customPrice);
            onProductSelected({ ...p, price: isNaN(price) ? 0 : price });
            setInputFocus(true);
            setTimeout(() => inputRef.current?.focus(), 0);
        };

        return (
            <button
                key="custom"
                className={"ProductItem asButton customBtn " + (isSelected ? "selected" : "")}
                onClick={handleClick}
            >
                {isSelected ? (
                    <input
                        ref={inputRef}
                        className="customPriceInput"
                        type="number"
                        value={customPrice}
                        min={0}
                        autoFocus
                        onClick={(e) => e.stopPropagation()}
                        onBlur={() => setInputFocus(false)}
                        onChange={(e) => {
                            const raw = e.target.value;
                            setCustomPrice(raw);
                            const price = parseFloat(raw);
                            if (!isNaN(price))
                                onProductSelected({ ...p, price });
                        }}
                    />
                ) : (
                    <span>{_t(`${trKey}.other`)}</span>
                )}
            </button>
        );
    };

    return ({
        [ViewMode.DEFAULT]: ()=>renderProduct(product),
        [ViewMode.CUSTOM]: ()=>renderCustomProduct(product),
        [ViewMode.AS_BUTTON]: ()=>renderProductAsButton(product),
    })[currentViewMode]();
}

ProductItemMobile.propTypes = {
    product: PropTypes.any,
    viewMode: PropTypes.number,
    hasUsedPromo: PropTypes.bool,
}

export default ProductItemMobile;